export const getAPIVersion = (): AtMetaAPIVersion => {
  return (process.env.REACT_APP_API_VERSION as any) || 'api2';
};
